import { useLazyQuery, useMutation } from '@apollo/client';
import images from '../../assets/images';
import './Workshop.scss';
import {
    EDIT_WORKSHOP_UPLOADED_VIDEO,
    GET_ALL_SCHEDULED_WORKSHOPS,
    GET_ALL_WORKSHOPS_VIDEOS,
    GET_WORKSHOP_BY_ID,
    SCHOOL_ADMIN_WORKSHOP,
    UPDATE_PLAY_BACK_TIME,
    UPDATE_WORKSHOP_MEETING_ID,
    UPLOAD_WORKSHOP_VIDEO,
} from "./api/WorkshopQuery";
import { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react';
import CreateSchedule from '../../components/CreateSchedule/CreateSchedule';
import WorkshopLibrary from '../../components/WorkshopLibrary/WorkshopLibrary';
import dayjs from 'dayjs';
import ToasterWithMessage from '../../components/toaster';
import { FETCH_POLICY, FETCH_POLICY_NO_CACHE, JITSI, SCHOOL_ADMIN, TEACHER_ROLE } from '../../utils/constants';
import { useAppSelector } from '../../redux/app/hooks';
import Loader from '../../components/Loader/Loader';
import UploadToaster from '../../components/Popups/UploadProgressBar/UploadProgressPopup';
import FileUpload from '../../components/Popups/FileUpload';
import { debounce } from 'lodash';
import { useDispatch } from 'react-redux';
import {
    setCurrentSessionDetail,
    setCurrentSessionRecordingDetail,
    setCurrentVideoData,
    setCurrentWorkshopId,
    setIsStartingMeeting,
    setMeetComponentName,
} from "../../redux/slices/dashboardSlice";
import { visibility } from '../../redux/slices/rightSideAd';
import { useGlobalState } from '../../MeetContext/MeetContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useChimeMeeting } from '../../Chime/ChimeMeetingContext';
import { getChimeParticipants } from '../../Chime/helpers/get-participants';
import { getScreenDimensions, generateUniqueMeetingId } from '../../utils/helper';
import MobileHeader from '../../components/MobileHeader/MobileHeader';
import MobileScreenHeader from '../../components/MobileScreenHeader/MobileScreenHeader';
import { Tooltip } from '@mui/material';
import { trackButtonClick, trackMettingEvent } from '../../firebase/analyticsHelper';
import { ButtonClickEvents, Pages } from '../../firebase/constants/events';
import { captureEvent, updateUserProperties } from '../../utils/PostHogHelper';
import CommonBulkUpload, { BulkFileState } from '../../components/Popups/CommonBulkUpload/CommonBulkUpload';
import { UploadedFilePayload } from '../SyndicatedVideos/SyndicatedVideos';
import UploadResultModal, { UploadResult, UploadResultForTeacher, UploadResultForWorkshop } from '../AdminBulkUpload/components/UploadResultModal';
import { useMeetingManager } from 'amazon-chime-sdk-component-library-react';
import { createChimeMeeting } from '../../Chime/helpers/create-meeting';
const REPLICA_THRESHOLD = parseInt(process.env.REACT_APP_REPLICA_THRESHOLD ?? "240");

export interface ClickedWorkshopDetails{
    type?: "workshop",
    isActive: boolean,
    wsDescription: string,
    wsTopic: string,
    wsId: string,
    wsEndTime: string,
    wsInteractionsPeriod: string,
    wsTeachingPeriod:string,
    wsStartTime: string,
    wsStatus: string,
    wsCode: string,
    hostId?: string,
    isRecordStart: boolean,
    recordStartTime:string| null,
    wsParticipantsCount: number;
    feedsByWsId: {
        nodes: [
            {
                fId: string;
            }
        ]
    }
    serverUrl?: string | null;
    botUrl?: string | null;
    meetingType?: string | null;
    participantIds: string[];
    replicaMeetingIds?: string[];
    showChat: boolean;
    originalHostId : string;
    mediaPipelineArn : string;
    mediaPipelineId : string;
}

interface SubType{
    wsDescription: string;
    wsTopic: string;
    wsId: string;
}

export interface SingleObjectType{
    seId: string,
    seTitle: string,
    seDescription: string,
    createdAt: string,
    seUrl: string,
    seType: string,
    sePlaybackTime: string | null,
    workshopByWsId: SubType | null,
    videosPlaybacktimesBySeId: VideoPlayBackType,
    filetype: string;
    fileinfo: any;
}

export interface VideoPlayBackType{
    nodes: VideoPlayBackNodeType[]
}

export interface VideoPlayBackNodeType {
    playbackTime: string,
    vpId: string,
}
export interface WorkshopVideosType{
    nodes: SingleObjectType[],
    totalCount: number
}

const Workshop: FunctionComponent = () => {
    
  const {error, success} = ToasterWithMessage();
  const {backArrow, searchIcon, uploadCloud, ScheduleWorkshopGif, BluePlayButton, whiteCrossIcon, searchCloseIcon, plusIcon} = images;
  const [showCreateScheduling, setShowCreateScheduling] = useState<boolean>(false);
  const [editClicked, setEditClicked] = useState<boolean>(false);
  const [singleSessionDetail,setSingleSessionDetail] = useState<ClickedWorkshopDetails>();
  const [clickedSessionDetails,setClickedSessionDetails] = useState<ClickedWorkshopDetails>();
  const [isClickedSessionDetail,setIsClickedSessionDetail] = useState<boolean>(false);
  const [isDeleted,setIsDeleted] = useState<boolean>(false);
  const [liveSessionsList,setLiveSessionsList] = useState<ClickedWorkshopDetails[]>([]);
  const [sessionEnded, setSessionEnded] = useState<boolean>(false);
  const [isWorkshopUploadOpen, setIsWorkshopUploadOpen] = useState<boolean>(false);
  const [workshopOpen, setWorkshopOpen] = useState<boolean>(false);
  const [workshopDescription, setWorkshopDescription] = useState<string>();
  const [videoUrl, setVideoUrl] = useState<string>();
  const [videoFileName, setVideoFileName] = useState<string>();
  const [videoFileData, setVideoFileData] = useState<File | null>();
  const [workshopUploaded, setWorkshopUploaded] = useState(false);
  const [workshopUploadFailed, setWorkshopUploadFailed] = useState<boolean>(false);
  const [workshopUploadProgress, setWorkshopUploadProgress] = useState(0);
  const [workshopUploadFileName, setWorkshopUploadFileName] = useState<string>('');
  const [allSavedUploadedVideosList,setAllSavedUploadedVideosList] = useState<SingleObjectType[]>();
  const [refetch, SetRefetch] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState(0);
  const [isVideoUploaded, setIsVideoUploaded] = useState<boolean>(false);
  const [clickedVideoUrl,setClickedVideoUrl] = useState<string>('');
  const [clickedVideoDescription, setClickedVideoDescription] = useState<string>('');
  const [searchValue, setSearchValue] = useState<string>('');
  const [clickedVideoData, setClickedVideoData] = useState<SingleObjectType | null>(null);
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const clickedVideoRefValue = useAppSelector((state) => state.dashboard.clickedVideoData);
  const profile = useAppSelector((state) => state?.auth?.adminProfile);
  const [isAdminButtonClicked, setIsAdminButtonClicked] = useState<boolean>(false);
  const [isTeacherButtonClicked, setIsTeacherButtonClicked] = useState<boolean>(false);
  const [isMoreClick,SetIsMoreClick] = useState<boolean>(false);
  const [hasMore, setHasMore] = useState(false);
  const [offset, setOffset] = useState(0);
  const [initialLoading, setInitialLoading] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [overallCount, setOverallCount] = useState<number>(0);
  const pageSize = 15;
  const {
      createMeeting,
      joinMeeting,
      setIsRecording,
      setRecordingStartTime,
      showChat,
      setShowChat,
      setHostId,
      setHostAttendeeId,
      setMediaPipelineArn,
      setMediaPipelineId,
  } = useChimeMeeting();
  const navigate = useNavigate();
  const {state} = useLocation();
  const [isSearchClick, setisSearchClick] = useState<boolean>(false);
  const profileImage = useAppSelector((state) => state?.auth?.adminProfileImage);
  const StudentName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;

  const [FilesStatusData, setFilesStatusData] = useState<Array<BulkFileState>>([]);
  const [uploadedPayloads, setUploadedPayloads] = useState<UploadedFilePayload[]>([]);
  const [totalProgress, setTotalProgress] = useState<number>(0);
  const [successCount, setSuccessCount] = useState<number>(0);
  const [failureCount, setFailureCount] = useState<number>(0);
  const [uploadResults, setUploadResults] = useState<UploadResult[]>([]);
  const [upoloadResultsForWorkshop, setUploadResultsForWorkshop] = useState<UploadResultForWorkshop>();
  const [isModalOpen, setIsModalOpen] = useState(false);  
  const [isEditVideo, setIsEditVideo] = useState<boolean>(false);
  const [selectedSingleVideo, setSelectedSingleVideo] = useState<SingleObjectType | null>(null);
  const [hasSubmittedForEdit, setHasSubmittedForEdit] = useState<boolean>(false);
  const meetingManager = useMeetingManager();

  const dispatch = useDispatch();
  const {localStream, setIsMeetingEndByHost} = useGlobalState();
  const { role, meetService, loginpage } = useAppSelector((state) => state.auth);
  const meetingService = meetService;
  console.log("[log] Workshop", meetingService);
  
    
const [getAllScheduledWorkshops, {loading}] = useLazyQuery(GET_ALL_SCHEDULED_WORKSHOPS, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      setLiveSessionsList(data?.getAllWorkShops);
      setClickedSessionDetails(undefined);
      setIsClickedSessionDetail(false);
      setIsDeleted(false);
    },
    onError: (err) => {
        error(err?.message);
    }
  });


  const [ getAllWorkshopsVideos, {loading: getAllVideoLoading} ] = useLazyQuery(GET_ALL_WORKSHOPS_VIDEOS, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      setOffset((prev) => prev + pageSize);
      setTotalCount(data?.allWorkshopSessions?.totalCount);
      setOverallCount(data?.overAllCount?.totalCount);
      setAllSavedUploadedVideosList((prevFeeds: any) => {
        const updatedVideos = initialLoading ? data?.allWorkshopSessions?.nodes : [...prevFeeds, ...data?.allWorkshopSessions?.nodes];
        setHasMore(updatedVideos?.length < (data?.allWorkshopSessions?.totalCount ?? 0));
        return updatedVideos;
      });
      if (initialLoading) {
        setInitialLoading(false);
      }
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [ getSchoolAdminWorkshop, {loading: getSchoolAdminWorkshopLoading} ] = useLazyQuery(SCHOOL_ADMIN_WORKSHOP, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      setOffset((prev) => prev + pageSize);
      setTotalCount(data?.allWorkshopSessions?.totalCount);
      setOverallCount(data?.overAllCount?.totalCount);
      setAllSavedUploadedVideosList((prevFeeds: any) => {
        const updatedVideos = initialLoading ? data?.allWorkshopSessions?.nodes : [...prevFeeds, ...data?.allWorkshopSessions?.nodes];
        setHasMore(updatedVideos?.length < (data?.allWorkshopSessions?.totalCount ?? 0));
        return updatedVideos;
      });
      if (initialLoading) {
        setInitialLoading(false);
      }
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [updatePlayBackTime] = useMutation(UPDATE_PLAY_BACK_TIME, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
        SetRefetch(!refetch);
        dispatch(setCurrentVideoData({
            videoCurrentTime: 0,
            videoId: ''
        }));
    },
    onError: (err) => {
        error(err?.message);
    }
});


  const [updateSessionId] = useMutation(UPDATE_WORKSHOP_MEETING_ID, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
        fetchSessionDetails();
    },
    onError: (err) => {
      setIsAdminButtonClicked(false);
      dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
    }
});

const fetchSessionDetails = () => {
    if (singleSessionDetail) {
        getSingleSession({
            variables: {
                input: {
                    wsId: singleSessionDetail?.wsId
                }
            }
        })
    }
  };

const [getSingleSession] = useLazyQuery(GET_WORKSHOP_BY_ID, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
        const response = data?.getWorkShopByWsId || {};
        const meetId = response?.wsCode;

        if (meetId && meetingService !== JITSI) {
            getChimeParticipants(meetId)
                .then((participantsResponse) => {
                    response.wsParticipantsCount = participantsResponse?.Attendees ? participantsResponse?.Attendees?.length : 0;
                })
                .catch(() => {
                    response.wsParticipantsCount = 0;
                })
                .finally(() => {
                    console.log("[Log] Participants count:", response?.wsParticipantsCount);
                    if (isMoreClick === false) {
                        //this state is using for start and join session card place
                        setSingleSessionDetail(response);
                    } else {
                        //this state is using for edit and delete session
                        setClickedSessionDetails({ ...response, type: "workshop" });
                    }
                });
        } else {
            if (isMoreClick === false) {
                //this state is using for start and join session card place
                setSingleSessionDetail(response);
            } else {
                //this state is using for edit and delete session
                setClickedSessionDetails({ ...response, type: "workshop" });
            }
        }
        setSessionEnded(false);
    },
    onError: (err) => {
    dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
    if(err?.message === "Workshop has ended"){
         setSessionEnded(true);
         setTimeout(() => {
          setSingleSessionDetail(undefined);
          fetchUpcomingSessions();
        }, 5000); 
      }else {
        error(err?.message)
      }
    }
  });
  

    const handleStartMeeting = async (stream?: any) => {
        trackButtonClick(ButtonClickEvents?.START_MEETING, {
            description : "User clicked start meeting button",
            page: 'Workshop'
        });

        dispatch(setMeetComponentName({ meetComponent: 'workshop' }));
        if (meetingService === JITSI) {
            // Check for Jitsi server url
            if (!singleSessionDetail?.serverUrl) {
                error("Meeting Server setup in progress.");
                if (role === SCHOOL_ADMIN) {
                    setIsAdminButtonClicked(false);
                } else if (role === TEACHER_ROLE) {
                    setIsTeacherButtonClicked(false);
                }
                return;
            }

            const userId = profile?.getCurrentUser?.nodes?.[0]?.uId;
            const userName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;
            const meetingId = generateUniqueMeetingId();

            try {
                // updateSessionId({
                //     variables: {
                //         updateInput: {
                //             wsCode: meetingId,
                //             wsStatus: "STARTED",
                //             hostId: userId,
                //         },
                //         wsId: singleSessionDetail?.wsId
                //     }
                // })
                if (singleSessionDetail?.wsId) {
                    dispatch(setCurrentWorkshopId({ currentWorkshopId: singleSessionDetail?.wsId }));
                    dispatch(
                        setCurrentSessionDetail({
                            startDate: singleSessionDetail?.wsStartTime,
                            endDate: singleSessionDetail?.wsEndTime,
                            mediaPipelineArn:
                                singleSessionDetail?.mediaPipelineArn ?? null,
                            mediaPipelineId:
                                singleSessionDetail?.mediaPipelineId ?? null,
                        }),
                    );
                    dispatch(
                        setCurrentSessionRecordingDetail({
                            recordingStartedTime:
                                singleSessionDetail?.recordStartTime,
                            recordingStarted:
                                singleSessionDetail?.isRecordStart,
                        }),
                    );
                }
                if(meetingId && userId) {
                trackMettingEvent(`${singleSessionDetail?.wsStatus === "STARTED" ? "j" : "s"}`, {
                  meetingId,
                  participantId: userId,
                });
                }
                if(userId) {
                    updateUserProperties({
                        meetingId,
                    });
                    captureEvent(userId, {
                        role,
                        loginType: loginpage, // your redux login type
                        meetingId,
                    });
                }
                const existingState = state; // coming from useLocation() or props

                const newState = {
                    ...existingState,                // ✅ spread existing values
                    meetingId,
                    userName,
                    isHost: true,
                    isCreateMeeting: true,
                    hostId: userId,
                    userId,
                    meetComponent: 'workshop',
                    jitsiUrls: {
                        jitsiMeetUrl: singleSessionDetail?.serverUrl,
                        jitsiBotUrl: singleSessionDetail?.botUrl
                    }
                };

                // Save to storage
                localStorage.setItem("meetingState", JSON.stringify(newState));
                localStorage.setItem("isJoined", "joined");

                // Open in new tab
                if(window?.electron && window?.electron?.isElectron()){
                    window?.electron?.openMeetingWindow(`admin-workshop/meeting?meetId=${meetingId}`, newState);
                }else {
                    window.open(`/admin-workshop/meeting?meetId=${meetingId}`, "_blank");
                }

                console.log("[Log state jitsi start] state", state);
                console.log("[Log state jitsi start] after appending state", {
                    ...state,
                    meetingId,
                    userName,
                    isHost: true,
                    isCreateMeeting: true,
                    hostId: userId,
                    userId,
                    meetComponent: "workshop",
                    jitsiUrls: {
                        jitsiMeetUrl: singleSessionDetail?.serverUrl,
                        jitsiBotUrl: singleSessionDetail?.botUrl,
                    },
                });
            }
            catch (e) {
                setIsAdminButtonClicked(false);
                localStorage.setItem("isJoined", "left");
            }
        }
        else {
            const userId = profile?.getCurrentUser?.nodes?.[0]?.uId;
            await createMeeting(userId).then(async (response) => {
                console.log('[Log] createMeeting response', response);
                const meetId = response?.Meeting?.MeetingId;
                trackMettingEvent(`${singleSessionDetail?.wsStatus === "STARTED" ? "j" : "s"}`, {
                  meetingId: meetId!,
                  participantId: userId,
                });
                if (meetId) {
                    if(userId) {
                        updateUserProperties({
                            meetingId: meetId, // overwrite old value
                        });
                        captureEvent(userId, {
                            role: role,
                            loginType: loginpage, // your redux login type
                            meetingId: meetId,
                        });
                    }
                    try {
                        console.log("check createmeeting");
                    } catch (err) {
                        setIsAdminButtonClicked(false);
                        dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
                    }

                    const participants = await getChimeParticipants(meetId);
                    let hostAttendee:any = null;
                    // Find the host attendee
                    if(participants?.Attendees){
                        hostAttendee =  participants.Attendees.find(
                            (attendee) => attendee.ExternalUserId === userId
                        );
                    }

                    console.log("Host AttendeeId while creating:", hostAttendee?.AttendeeId);
                    localStorage.setItem("hostId", userId ?? "");
                    localStorage.setItem("hostAttendeeId", hostAttendee?.AttendeeId ?? "");
                    setHostAttendeeId(hostAttendee?.AttendeeId || '');

                    await updateSessionId({
                        variables: {
                            updateInput: {
                                wsCode: meetId,
                                wsStatus: "STARTED",
                                hostId: userId,
                                showChat: singleSessionDetail?.wsStatus === "NOT_STARTED" ? showChat : singleSessionDetail?.showChat,
                                originalHostId : userId
                            },
                            wsId: singleSessionDetail?.wsId
                        }
                    })
                    if (singleSessionDetail?.wsId) {
                        if (singleSessionDetail?.wsStatus === "STARTED") {
                            setShowChat(singleSessionDetail?.showChat);
                        }
                        dispatch(setCurrentWorkshopId({ currentWorkshopId: singleSessionDetail?.wsId }));
                        localStorage.setItem("SessionId",singleSessionDetail?.wsId);
                        dispatch(
                            setCurrentSessionDetail({
                                startDate: singleSessionDetail?.wsStartTime,
                                endDate: singleSessionDetail?.wsEndTime,
                                mediaPipelineArn:
                                    singleSessionDetail?.mediaPipelineArn ??
                                    null,
                                mediaPipelineId:
                                    singleSessionDetail?.mediaPipelineId ??
                                    null,
                            }),
                        );
                        dispatch(
                            setCurrentSessionRecordingDetail({
                                recordingStartedTime:
                                    singleSessionDetail?.recordStartTime,
                                recordingStarted:
                                    singleSessionDetail?.isRecordStart,
                            }),
                        );
                    }        
                    if(meetId && userId) {
                    trackMettingEvent(`${singleSessionDetail?.wsStatus === "STARTED" ? "j" : "s"}`, {
                        meetingId: meetId!,
                        participantId: userId,
                    });     
                    }
                    if(userId) {
                        updateUserProperties({
                            meetingId: meetId, // overwrite old value
                        });
                        captureEvent(userId, {
                            role,
                            loginType: loginpage, // your redux login type
                            meetingId: meetId,
                        });
                    }  
                    navigate(`/admin-workshop/meeting?meetId=${meetId}`, { state: { ...state, sessionId: singleSessionDetail?.wsId } });
                    }
            }).catch((err) => {
                setIsAdminButtonClicked(false);
                dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
                stream.getAudioTracks()[0].stop();
                stream.getVideoTracks()[0].stop();
            });
        }
    };

    const handleJoinMeeting = async (stream?: any) => {
        trackButtonClick(ButtonClickEvents?.JOIN_MEETING, {
            description : "User clicked join meeting button",
            page: 'Workshop'
        });

        dispatch(setMeetComponentName({ meetComponent: 'workshop' }));
        if (meetingService === JITSI) {
            // Check for Jitsi server url
            if (!singleSessionDetail?.serverUrl) {
                error("Meeting Server setup in progress.");
                if (role === SCHOOL_ADMIN) {
                    setIsAdminButtonClicked(false);
                } else if (role === TEACHER_ROLE) {
                    setIsTeacherButtonClicked(false);
                }
                return;
            }
            
            const userId = profile?.getCurrentUser?.nodes?.[0]?.uId;
            const userName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;

            try {
                if (singleSessionDetail?.wsId) {
                    dispatch(setCurrentWorkshopId({ currentWorkshopId: singleSessionDetail?.wsId }));
                    dispatch(
                        setCurrentSessionDetail({
                            startDate: singleSessionDetail?.wsStartTime,
                            endDate: singleSessionDetail?.wsEndTime,
                            mediaPipelineArn:
                                singleSessionDetail?.mediaPipelineArn ?? null,
                            mediaPipelineId:
                                singleSessionDetail?.mediaPipelineId ?? null,
                        }),
                    );
                    dispatch(
                        setCurrentSessionRecordingDetail({
                            recordingStartedTime:
                                singleSessionDetail?.recordStartTime,
                            recordingStarted:
                                singleSessionDetail?.isRecordStart,
                        }),
                    );
                    setRecordingStartTime(singleSessionDetail?.recordStartTime);
                    setIsRecording(singleSessionDetail?.isRecordStart);
                }
                if(singleSessionDetail?.wsCode && userId) {
                trackMettingEvent("j", {
                  meetingId: singleSessionDetail?.wsCode,
                  participantId: userId,
                });
                }
                if(userId) {
                    updateUserProperties({
                         meetingId: singleSessionDetail?.wsCode, // overwrite old value
                    });
                    captureEvent(userId, {
                        role,
                        loginType: loginpage, // your redux login type
                        meetingId: singleSessionDetail?.wsCode,
                    });
                }

                const existingState = state; // coming from useLocation() or props

                console.log("[Log state jitsi join] state", state);
                console.log("[Log state jitsi join] after appending state", {
                    ...state,
                    meetingId: singleSessionDetail?.wsCode,
                    userName: userName,
                    isHost:
                        singleSessionDetail?.hostId &&
                        userId === singleSessionDetail.hostId,
                    isCreateMeeting: false,
                    hostId: singleSessionDetail?.hostId,
                    userId,
                    meetComponent: "workshop",
                    jitsiUrls: {
                        jitsiMeetUrl: singleSessionDetail?.serverUrl,
                        jitsiBotUrl: singleSessionDetail?.botUrl,
                    },
                });
                if (role === SCHOOL_ADMIN) {
                const newState = {
                ...existingState,   
                meetingId: singleSessionDetail?.wsCode, 
                userName: userName, 
                isHost: singleSessionDetail?.hostId && userId === singleSessionDetail.hostId, 
                isCreateMeeting: false, 
                hostId: singleSessionDetail?.hostId, 
                userId, 
                meetComponent: 'workshop', 
                jitsiUrls: { 
                    jitsiMeetUrl: singleSessionDetail?.serverUrl, 
                    jitsiBotUrl: singleSessionDetail?.botUrl 
                }
                };

                // Save to storage
                localStorage.setItem("meetingState", JSON.stringify(newState));
                localStorage.setItem("isJoined", "joined");

                if(window?.electron && window?.electron?.isElectron()){
                    window?.electron?.openMeetingWindow(`admin-workshop/meeting?meetId=${singleSessionDetail?.wsCode}`, newState);
                } else {
                   window.open(`/admin-workshop/meeting?meetId=${singleSessionDetail?.wsCode}`, "_blank");
                }

                } else if (role === TEACHER_ROLE) {
                const newState = {
                ...existingState,   
                meetingId: singleSessionDetail?.wsCode, 
                userName: userName, 
                isHost: false, 
                isCreateMeeting: false, 
                hostId: singleSessionDetail?.hostId, 
                userId, 
                meetComponent: 'workshop', 
                jitsiUrls: { 
                    jitsiMeetUrl: singleSessionDetail?.serverUrl, 
                    jitsiBotUrl: singleSessionDetail?.botUrl 
                }
                };

                // Save to storage
                localStorage.setItem("meetingState", JSON.stringify(newState));
                localStorage.setItem("isJoined", "joined");

                if(window?.electron && window?.electron?.isElectron()) {
                    window.electron.openMeetingWindow(`teacher-workshop/meeting?meetId=${singleSessionDetail?.wsCode}`, newState);
                } else {
                    window.open(`/teacher-workshop/meeting?meetId=${singleSessionDetail?.wsCode}`, "_blank");
                }
                }
            }
            catch (err) {
                localStorage.setItem("isJoined", "left");
                if (role === SCHOOL_ADMIN) {
                    setIsAdminButtonClicked(false);
                } else if (role === TEACHER_ROLE) {
                    setIsTeacherButtonClicked(false);
                }
            }
        }
        else {
            const userId = profile?.getCurrentUser?.nodes?.[0]?.uId;

            if (singleSessionDetail?.wsCode && singleSessionDetail?.hostId) {
                let primaryMeetingId = singleSessionDetail?.wsCode;
                const replicaMeetingIds: string[] = singleSessionDetail?.replicaMeetingIds || [];

                // Combine the primary meeting and any replica meetings into one list
                const allMeetingIds = [primaryMeetingId, ...replicaMeetingIds];
                console.log("All Meeting Ids:", allMeetingIds);

                // Fetch participant counts for all meeting IDs in parallel
                const meetingCountsPromises = allMeetingIds.map(async (id) => {
                    const response = await getChimeParticipants(id);
                    const count = response?.Attendees ? response?.Attendees?.length : 0;
                    return { id, count };
                });
                const meetingCounts = await Promise.all(meetingCountsPromises);
                console.log("Meeting Counts:", meetingCounts);

                // Decide which meeting instance to join: choose the first meeting that isn't full.
                let chosenMeetingId: string | null = null;
                for (const { id, count } of meetingCounts) {
                    if (count < REPLICA_THRESHOLD) {
                        chosenMeetingId = id;
                        break;
                    }
                }

                // If all existing meeting instances are full, create a new replica meeting.
                if (!chosenMeetingId) {
                    const replicaMeetingResponse = await createChimeMeeting(singleSessionDetail?.wsCode);
                    const newReplicaMeetingId = replicaMeetingResponse?.Meeting?.MeetingId;
                    if (newReplicaMeetingId) {
                        // Update the replica meetings array by appending the new meeting ID.
                        const updatedReplicaMeetingIds = [...replicaMeetingIds, newReplicaMeetingId];
                        await updateSessionId({
                            variables: {
                                updateInput: { replicaMeetingIds: updatedReplicaMeetingIds },
                                wsId: singleSessionDetail?.wsId,
                            },
                        });
                        chosenMeetingId = newReplicaMeetingId;
                    }
                }

                // Fallback: if still no meeting is chosen, default to primary meeting
                const finalMeetingId = chosenMeetingId || primaryMeetingId;
                const originalHostId =  singleSessionDetail.originalHostId

                let hostAttendee:any = null;
                let hostExternalUserId:any = '';

                // Assume you already have these
                await getChimeParticipants(finalMeetingId)
                .then((participants) => {
                    console.log("[Log] Participants List:", participants);
                    console.log("userId", userId, "singleSessionDetail.hostId", singleSessionDetail.hostId, "originalHostId", originalHostId)
                    if(userId === originalHostId) {
                    hostExternalUserId = userId;
                    } else {
                    hostExternalUserId = singleSessionDetail.hostId;
                    }
                    // Find the host attendee
                    if(participants?.Attendees){
                        console.log("by using this hostExternalUserId", hostExternalUserId);
                        hostAttendee = participants.Attendees.find((attendee:any) => {
                            console.log("Checking attendee:", attendee.ExternalUserId);
                            return attendee.ExternalUserId === hostExternalUserId;
                        });
                    }
                })
                .catch((err) => {
                    console.error("Failed to fetch participants:", err);
                });

                
                if (hostAttendee) {
                console.log("Host AttendeeId:", hostAttendee.AttendeeId);
                } else {
                console.log("Host not found in the participants list");
                }

                if(userId) {
                    updateUserProperties({
                         meetingId: singleSessionDetail?.wsCode, // overwrite old value
                    });
                    captureEvent(userId, {
                        role,
                        loginType: loginpage, // your redux login type
                        meetingId: singleSessionDetail?.wsCode,
                    });
                }
                
                console.log(userId, originalHostId, "originalHost")
                await joinMeeting(finalMeetingId, 
                    originalHostId === userId ? userId :
                     singleSessionDetail.hostId === userId
                        ? singleSessionDetail.hostId
                        : `${userId}|${Date.now()}`, 
                     singleSessionDetail.hostId, originalHostId, hostAttendee?.AttendeeId || '')
                    .then(async (response) => {
                        console.log('[Log] joinMeeting response', response);
                        const meetId = response?.meetingResponse?.Meeting?.MeetingId;
                        if (meetId) {
                            if (userId === originalHostId) {
                            await getChimeParticipants(meetId)
                                .then((participantsResponse) => {
                                    console.log("userId", userId, "singleSessionDetail.hostId", singleSessionDetail.hostId, "originalHostId", originalHostId)
                                    hostExternalUserId = userId;
                                    // Find the host attendee
                                    if(participantsResponse?.Attendees){        
                                        hostAttendee = participantsResponse.Attendees.find((attendee:any) => {
                                            console.log("Checking attendee:", attendee.ExternalUserId);
                                            return attendee.ExternalUserId === hostExternalUserId;
                                        });
                                        console.log("Host AttendeeId after joining:", hostAttendee?.AttendeeId || '');
                                        setHostAttendeeId(hostAttendee?.AttendeeId || '');
                                        console.log(singleSessionDetail.mediaPipelineArn, singleSessionDetail.mediaPipelineId, "mediapipeline", originalHostId)
                                        localStorage.setItem("hostId", userId ?? "");
                                        localStorage.setItem("hostAttendeeId", hostAttendee?.AttendeeId ?? ""); 
                                    }
                                })
                                .catch((err) => {
                                    console.error("Failed to fetch participants:", err);
                                });

                              console.log(userId, originalHostId, "originalHost")
                              setHostId(userId);
                              console.log(singleSessionDetail?.mediaPipelineArn, singleSessionDetail?.mediaPipelineId, "mediapipeline", originalHostId)
                              
                              setMediaPipelineArn(singleSessionDetail.mediaPipelineArn)
                              setMediaPipelineId(singleSessionDetail.mediaPipelineId)
                            meetingManager.audioVideo?.addObserver({
                            audioVideoDidStart: () => {
                                console.log('[Log] audioVideoDidStart - Sending realtime message');
                                try {
                                const message = {
                                    action: "host-changed",
                                    hostId: userId,
                                    hostAttendeeId: hostAttendee?.AttendeeId || '',
                                    ...(singleSessionDetail.mediaPipelineId && {
                                    mediaPipelineId: singleSessionDetail.mediaPipelineId,
                                    }),
                                    ...(singleSessionDetail.mediaPipelineArn && {
                                    mediaPipelineArn: singleSessionDetail.mediaPipelineArn,
                                    }),
                                };

                                meetingManager.meetingSession?.audioVideo?.realtimeSendDataMessage(
                                    "live-update",
                                    JSON.stringify(message)
                                );
                                } catch (err) {
                                console.error("Failed to send realtime message:", err);
                                }
                            },
                            });

                              await updateSessionId({
                                variables: {
                                  updateInput: {
                                    hostId: userId,
                                  },
                                  wsId: singleSessionDetail?.wsId,
                                },
                              });
                            }
                            try {
                               console.log("check joinmeeting");
                            } catch (err) {
                                dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
                                if (role === SCHOOL_ADMIN) {
                                    setIsAdminButtonClicked(false);
                                } else if (role === TEACHER_ROLE) {
                                    setIsTeacherButtonClicked(false);
                                }
                            }
                            if (singleSessionDetail?.wsId) {
                                 localStorage.setItem("SessionId",singleSessionDetail?.wsId);
                                dispatch(setCurrentWorkshopId({ currentWorkshopId: singleSessionDetail?.wsId }));
                                dispatch(
                                    setCurrentSessionDetail({
                                        startDate:
                                            singleSessionDetail?.wsStartTime,
                                        endDate: singleSessionDetail?.wsEndTime,
                                        mediaPipelineArn:
                                            singleSessionDetail?.mediaPipelineArn ??
                                            null,
                                        mediaPipelineId:
                                            singleSessionDetail?.mediaPipelineId ??
                                            null,
                                    }),
                                );
                                dispatch(
                                    setCurrentSessionRecordingDetail({
                                        recordingStartedTime:
                                            singleSessionDetail?.recordStartTime,
                                        recordingStarted:
                                            singleSessionDetail?.isRecordStart,
                                    }),
                                );
                                setRecordingStartTime(singleSessionDetail?.recordStartTime);
                                setIsRecording(singleSessionDetail?.isRecordStart);
                                setShowChat(singleSessionDetail?.showChat);
                            }
                            if(meetId && userId) {
                            trackMettingEvent("j", {
                                meetingId: meetId!,
                                participantId: userId,
                            });
                            }
                            if(userId) {
                                updateUserProperties({
                                    meetingId: meetId, // overwrite old value
                                });
                                captureEvent(userId, {
                                    role,
                                    loginType: loginpage, // your redux login type
                                    meetingId: meetId,
                                });
                            }
                            if (role === SCHOOL_ADMIN) {
                                navigate(`/admin-workshop/meeting?meetId=${meetId}`, { state: { ...state, sessionId: singleSessionDetail?.wsId } });
                            } else if (role === TEACHER_ROLE) {
                                navigate(`/teacher-workshop/meeting?meetId=${meetId}`, { state: { ...state, sessionId: singleSessionDetail?.wsId } });
                            }
                        }
                    }).catch(() => {
                        localStorage.setItem("isJoined", "left");
                        dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
                        if (role === SCHOOL_ADMIN) {
                            setIsAdminButtonClicked(false);
                        } else if (role === TEACHER_ROLE) {
                            setIsTeacherButtonClicked(false);
                        }
                        stream.getAudioTracks()[0].stop();
                        stream.getVideoTracks()[0].stop();
                    })
            }
        }
    };

useEffect(() => {
    if(clickedVideoData?.seId && clickedVideoUrl && clickedVideoRefValue?.videoCurrentTime){
        updatePlayBackTime({
            variables: {
                input: {
                    videosPlaybacktime: {
                        seId: clickedVideoData?.seId,
                        uId: profile?.getCurrentUser?.nodes[0]?.uId,
                        playbackTime: clickedVideoRefValue?.videoCurrentTime.toString()
                    }
                }
            }
        });
    }
   
},[clickedVideoRefValue]);


useEffect(() => {

    if(clickedVideoData?.videosPlaybacktimesBySeId?.nodes[0]?.playbackTime && videoRef?.current){
        videoRef.current.currentTime = parseFloat(clickedVideoData?.videosPlaybacktimesBySeId?.nodes[0]?.playbackTime);
    }
},[clickedVideoData]);

const handleOnMouseOut = () => {
    if(videoRef.current){
      dispatch(setCurrentVideoData({
        videoCurrentTime: videoRef?.current?.currentTime,
        videoId: clickedVideoData?.seId ? clickedVideoData?.seId : ''
      }))
    }
}

  const showNoWorkshopsDiv =
      !(liveSessionsList?.length > 0) &&
      !(allSavedUploadedVideosList && totalCount > 0) &&
      !showCreateScheduling &&
      !loading &&
      !(getAllVideoLoading || getSchoolAdminWorkshopLoading) &&
      !isVideoUploaded &&
      overallCount === 0;


    const [editUploadedVideo] = useMutation(EDIT_WORKSHOP_UPLOADED_VIDEO, {
          fetchPolicy: FETCH_POLICY,
          onCompleted: (data) => {
             if(data?.editWorkshopSession) {
                  setVideoFileData(null);
                  if(!(videoFileData && videoUrl)) {
                      success("File updated successfully!");
                  }
                  if(videoFileData && videoUrl) {
                      if (videoFileName) {
                          setWorkshopUploadFileName(videoFileName);
                      }
                      setWorkshopUploaded(true);
                      setWorkshopUploadProgress(100);
                  }
                  setVideoFileName('');
                  setVideoUrl('');
                  setHasSubmittedForEdit(false);
                  setOffset(0);
                  setAllSavedUploadedVideosList([]);
                  // get api for workshop videos
                    getSchoolAdminWorkshop({
                        variables: {
                            searchInput: `%${searchValue.trim()}%`,
                            limit: pageSize,
                            offset: 0,
                            seType: activeTab === 1 ? ['SAVED'] : activeTab === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
                        }
                    })
             }
          },
          onError: (err) => {
              error(err?.message);
              if (videoFileName) {
                  setWorkshopUploadFileName(videoFileName);
              }
              if(videoFileData && videoUrl) {
                  setWorkshopUploaded(true);
                  setWorkshopUploadProgress(0);
                  setWorkshopUploadFailed(true);
              }
          }
    });

  //To upload the video
  const [uploadWorkshopVideo] = useMutation(UPLOAD_WORKSHOP_VIDEO, {
    fetchPolicy: FETCH_POLICY_NO_CACHE,
    onCompleted: (data) => {
        if (data?.uploadMultipleWorkshopSessions) {
                setUploadedPayloads([]);

                const result = data.uploadMultipleWorkshopSessions;

                setUploadResultsForWorkshop(result);

                const hasFailures = result?.failed_count > 0;

                if (hasFailures) {
                    setIsModalOpen(true);
                } else {
                    success("Uploaded successfully!");
                }

            setIsVideoUploaded(true);
            setVideoFileData(null);
            if (videoFileName) {
                setWorkshopUploadFileName(videoFileName);
            }
            setWorkshopUploaded(true);
            setWorkshopDescription('');
            setWorkshopUploadProgress(100);
            setVideoFileName('');
            setVideoUrl('');
            SetRefetch(!refetch);
        }
    },
    onError: (err) => {
        setIsVideoUploaded(false);
        if (videoFileName) {
            setWorkshopUploadFileName(videoFileName);
        }
        setWorkshopUploaded(true);
        setWorkshopUploadProgress(0);
        setWorkshopUploadFailed(true);
    }
});

const fetchUpcomingSessions = () => {
    const currentDateUTC = dayjs().utc().format();

    getAllScheduledWorkshops({
        variables: {
            input: {
                startDate: currentDateUTC,
                isFacilitator: false
            },
        }
    })
  }

  const handleClickScheduleMeeting = () => {
    trackButtonClick(ButtonClickEvents?.SCHEDULE_MEETING, {
        description : "User clicked schedule meeting button",
        page : Pages.WORKSHOP_PAGE
      })
      if(role === SCHOOL_ADMIN){
        setShowCreateScheduling(true);
      }
  }

  const handleBackArrowAction = (prevVideoRef: any = null) => {
    if(showCreateScheduling){
        setShowCreateScheduling(false);
    } 
    if(singleSessionDetail?.wsId){
        setSingleSessionDetail(undefined);
    }
    if(isClickedSessionDetail){
        setIsClickedSessionDetail(true);
    }
    if(editClicked){
        setEditClicked(false);
    }
    if(clickedVideoUrl){
        if(prevVideoRef){
            updatePlayBackTime({
                variables: {
                    input: {
                        videosPlaybacktime: {
                            seId: clickedVideoData?.seId,
                            uId: profile?.getCurrentUser?.nodes[0]?.uId,
                            playbackTime: prevVideoRef?.currentTime.toString()
                        }
                    }
                }
            });
        }
        setClickedVideoUrl('');
        setClickedVideoDescription('');
        setClickedVideoData(null);
    }
  }

  const handleClickUploadIcon = () => {
        trackButtonClick(ButtonClickEvents?.UPLOAD_MATERIALS, {
            description: "User clicked the upload materials button",
            page : Pages.WORKSHOP_PAGE
        })
        setIsWorkshopUploadOpen(true);
        setWorkshopOpen(true);
  }

  const onClickCloseIcon = (event: any, prevVideoRef: any) => {
    if(prevVideoRef){
        updatePlayBackTime({
            variables: {
                input: {
                    videosPlaybacktime: {
                        seId: clickedVideoData?.seId,
                        uId: profile?.getCurrentUser?.nodes[0]?.uId,
                        playbackTime: prevVideoRef?.currentTime.toString()
                    }
                }
            }
        });
    }
    setClickedVideoUrl('');
    setClickedVideoDescription('');
    setClickedVideoData(null);
  }


  const handleSearchDebounce = useCallback(
    debounce((value, active) => {
        setSearchValue(value);
        setAllSavedUploadedVideosList([])
        setOffset(0);
        if (role === SCHOOL_ADMIN) {
            getSchoolAdminWorkshop({
                variables: {
                    searchInput: `%${value.trim()}%`,
                    limit: null,
                    offset: 0,
                    seType: active === 1 ? ['SAVED'] : active === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
                }
            })
        }
        else {
            getAllWorkshopsVideos({
                variables: {
                    searchInput: `%${value.trim()}%`,
                    limit: null,
                    offset: 0,
                    seType: active === 1 ? ['SAVED'] : active === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
                }
            })
        }
    }, 500),
    [getAllWorkshopsVideos, getSchoolAdminWorkshop]
);


const searchOnChange = (event: { target: { value: any; }; }) => {
    setSearchValue(event.target.value);
    if (handleSearchDebounce) {
        handleSearchDebounce(event?.target?.value, activeTab);
    }
}

  useEffect(() => {
        setIsMeetingEndByHost(false);
      dispatch(visibility({ isVisible: false }));
        dispatch(setCurrentSessionDetail({startDate: null, endDate: null, mediaPipelineArn: null, mediaPipelineId: null}))
        dispatch(setCurrentSessionRecordingDetail({recordingStartedTime: null, recordingStarted: false}));
      //To set stop camera and microphone when initial render.
      if(localStream?.getVideoTracks()[0]){
            localStream.getVideoTracks()[0].enabled = false;
        }
        localStream?.getVideoTracks()[0]?.stop();
        if(localStream?.getAudioTracks()[0]){
            localStream.getAudioTracks()[0].enabled = false;
        }
        localStream?.getAudioTracks()[0]?.stop();
  }, [])

  useEffect(() => {
    if(!isClickedSessionDetail){
      fetchUpcomingSessions();
    }
  },[isClickedSessionDetail, setIsClickedSessionDetail]);

  useEffect(() => {
    if (!showCreateScheduling || isDeleted) {
      fetchUpcomingSessions();
    }
  }, [showCreateScheduling, isDeleted]);
  

  useEffect(() => {
    setOffset(0);
    setAllSavedUploadedVideosList([]);
    if (role === SCHOOL_ADMIN) {
        getSchoolAdminWorkshop({
            variables: {
                searchInput: `%${searchValue.trim()}%`,
                limit: pageSize,
                offset: 0,
                seType: activeTab === 1 ? ['SAVED'] : activeTab === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
            }
        })
    }
    else {
        getAllWorkshopsVideos({
            variables: {
                searchInput: `%${searchValue.trim()}%`,
                limit: pageSize,
                offset: 0,
                seType: activeTab === 1 ? ['SAVED'] : activeTab === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
            }
        })
    }
}, [refetch]);

useEffect(() => {
    setInitialLoading(true);
    setOffset(0);
    localStorage.removeItem("hostId");
    localStorage.removeItem("hostAttendeeId");
}, [])


const loadMore = useCallback(() => {
    if (getAllVideoLoading || getSchoolAdminWorkshopLoading || !hasMore) {
        return;
    }
    
    if (role === SCHOOL_ADMIN) {
        getSchoolAdminWorkshop({
            variables: {
                searchInput: `%${searchValue?.trim()}%`,
                limit: pageSize,
                offset: offset,
                seType: activeTab === 1 ? ['SAVED'] : activeTab === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
            }
        })
    }
    else {
        getAllWorkshopsVideos({
            variables: {
                searchInput: `%${searchValue?.trim()}%`,
                limit: pageSize,
                offset: offset,
                seType: activeTab === 1 ? ['SAVED'] : activeTab === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
            }
        })
    }
  }, [ hasMore, offset, getAllWorkshopsVideos, getAllVideoLoading, getSchoolAdminWorkshop, getSchoolAdminWorkshopLoading]);

useEffect(() => {

    if (role === SCHOOL_ADMIN) {
        getSchoolAdminWorkshop({
            variables: {
                searchInput: `%${searchValue?.trim()}%`,
                limit: pageSize,
                offset: offset,
                seType: activeTab === 1 ? ['SAVED'] : activeTab === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
            }
        })
    }
    else {
        getAllWorkshopsVideos({
            variables: {
                searchInput: `%${searchValue?.trim()}%`,
                limit: pageSize,
                offset: offset,
                seType: activeTab === 1 ? ['SAVED'] : activeTab === 2 ? ['UPLOADED'] : ['SAVED', 'UPLOADED']
            }
        })
    }

},[activeTab])
const formatUploadedPayloads = (
    uploadedPayloads: UploadedFilePayload[],
    workshopDescription: string | undefined,
    ) => {

  const isSingle = uploadedPayloads.length === 1;
  return uploadedPayloads.map((item) => {
    console.log("item in formatUploadedPayloads", item);
    return {
        filename: item?.filename,
        seDescription: (isSingle && workshopDescription) ? workshopDescription?.trim() : item?.fileDescription,
        seUrl: item?.filepath
    };
    });
    };

    useEffect(() => {
        if(uploadedPayloads.length > 0 ){
            const updatedFormattedPayload = formatUploadedPayloads(
                uploadedPayloads,
                workshopDescription
            );

            if(role === SCHOOL_ADMIN){
            uploadWorkshopVideo({
               variables: {
                 saId: profile?.getCurrentUser?.nodes?.[0]?.schoolAdminsByUId?.nodes?.[0]?.saId,
                 sessions: updatedFormattedPayload
               },
             });
            }
        }
    }, [ uploadedPayloads ]);

    useEffect(() => {
        if (hasSubmittedForEdit === true) {
            let newFileName;
            let newFilePath;
            let newDescription;

            if(videoFileName !== selectedSingleVideo?.seTitle){
                newFileName = videoFileName?.replace(/\.pdf$/, "")?.trim();
            }
            if(videoUrl && videoFileData) {
                newFilePath = videoUrl;
            }
 
            if(workshopDescription && workshopDescription !== selectedSingleVideo?.seDescription) {
                newDescription = workshopDescription?.trim();
            }

            console.log("new values after assignment", newFileName, newFilePath, newDescription);

            editUploadedVideo({
                variables: {
                    input: {
                        seId: selectedSingleVideo?.seId,
                        ...(newFileName && {filename: newFileName}),
                        ...(newDescription && {seDescription: newDescription}),
                        ...(newFilePath && {seUrl: newFilePath})
                    }
                }
            });
        }
    }, [videoFileData, videoFileName, videoUrl, hasSubmittedForEdit]);

useEffect(() => {
    if (!clickedVideoUrl && showCreateScheduling) {
        dispatch(visibility({ isVisible: true }));
    }
    else {
        dispatch(visibility({ isVisible: false }));
    }
},[clickedVideoUrl, showCreateScheduling])

const handleSearchClick = () => {
    setisSearchClick(true);
}

const handleCloseSearch = () => {
    setisSearchClick(false);
    setSearchValue("");
    handleSearchDebounce("", activeTab);
}

const textRef = useRef<HTMLDivElement>(null);
const [isEllipsisActive, setIsEllipsisActive] = useState(false);

// Function to check if text is truncated
const checkEllipsis = useCallback(() => {
  if (textRef.current) {
    setIsEllipsisActive(textRef?.current?.scrollWidth > textRef?.current?.clientWidth);
  }
}, []);

useEffect(() => {
  checkEllipsis(); // Check on mount
  window.addEventListener("resize", checkEllipsis); // Recheck on resize

  return () => window.removeEventListener("resize", checkEllipsis); // Cleanup on unmount
}, [checkEllipsis]);


  useEffect(() => {
        const accessTokenInterval = setInterval(async () => {
            const isJoinedMeeting = localStorage.getItem("isJoined");
            if((isJoinedMeeting === 'joined') || (isJoinedMeeting === '')) {
              setIsTeacherButtonClicked(false);
              setIsAdminButtonClicked(false);
              dispatch(setIsStartingMeeting({ isStartingMeeting: false }));
              localStorage.removeItem("closewindow");
            }
        }, 1000);        
        return () => {
            clearInterval(accessTokenInterval);
        }
  }, []);

// Recheck ellipsis on hover
const handleMouseEnter = () => {
  checkEllipsis();
};

  return (
    <div className='workshopMainContainer' style={{gap: showCreateScheduling ? '10px' : '', paddingBottom: showCreateScheduling ? '46px' : ''}}>
        {
                ((!loading && !(getAllVideoLoading || getSchoolAdminWorkshopLoading) && (showCreateScheduling)) || clickedVideoUrl) ?
                <div className='backArrowContainer' onClick={() => {
                    let prevVideoRef;
                    if(videoRef?.current){
                        prevVideoRef = {
                            currentTime: videoRef?.current?.currentTime
                        }
                    }
                    handleBackArrowAction(prevVideoRef);
                }}>
                        <img
                            className="backArrow"
                            alt="back-arrow"
                            src={backArrow}
                        />
                        {clickedVideoUrl && <Tooltip title={isEllipsisActive ? clickedVideoDescription ?? "" : ""} disableHoverListener={!isEllipsisActive}>
          <div ref={textRef} className="videoDescriptionStyle" onMouseEnter={handleMouseEnter}>
            {clickedVideoDescription}
          </div>
        </Tooltip>}
                </div>
                : <></>
        }
        {
                ((!loading) && clickedVideoUrl &&  !(getAllVideoLoading || getSchoolAdminWorkshopLoading)) || (showCreateScheduling)
                ? <></>
                :
                <>
                    {getScreenDimensions()?.isMobileScreen && !isSearchClick && !singleSessionDetail?.wsId && 
                        <MobileScreenHeader
                            handleSearchClick={handleSearchClick}
                            profileImage={profileImage}
                            role={role}
                            studentName={StudentName}
                            profile={profile}
                        />
                    } 
                    <div className={`workshopHeader ${(singleSessionDetail?.wsId && !isSearchClick && getScreenDimensions()?.isMobileScreen) ? "mobileWorkshopHeader" : ""}`}>        
                        <div className='workshopTitleContainer'>
                                {
                                    (singleSessionDetail?.wsId && !isSearchClick) ?
                                    <div className='backArrowContainer' onClick={handleBackArrowAction}>
                                        <img
                                            className="backArrow"
                                            alt="back-arrow"
                                            src={backArrow}
                                        />
                                    </div>
                                    : <></>
                                }
                                
                            {((!isSearchClick && getScreenDimensions()?.isMobileScreen) || (!getScreenDimensions()?.isMobileScreen)) && (
                                <div className='titlesStyle'>
                                    <div className='workshopMainTitle'>{'Workshop Library'}</div>
                                    <div className='workshopSubTitle'>Learn how others are improving</div>
                                </div>
                            )}
                        </div>
                        {getScreenDimensions()?.isMobileScreen && !isSearchClick && singleSessionDetail?.wsId && <MobileHeader handleSearchClick={handleSearchClick} />}
                        {
                        (!(singleSessionDetail?.wsId && role === TEACHER_ROLE) && 
                         ((getScreenDimensions()?.isMobileScreen && isSearchClick) || 
                          (liveSessionsList?.length > 0) || 
                          isVideoUploaded || 
                          (allSavedUploadedVideosList && totalCount > 0) || overallCount > 0
                         ))  ?
                            <div className={`workshopSearch ${(getScreenDimensions()?.isMobileScreen && isSearchClick) ? 'mobileSearch' : ''}`}>
                                <div className='SearchIconContainer'><img src={searchIcon} alt='searchIcon' className='commonSearchIconStyle' /></div>
                                <input id="searchBox" type='text' placeholder='Search' onChange={searchOnChange} value={searchValue} className='SearchInputFieldStyle' />
                                {(getScreenDimensions()?.isMobileScreen && isSearchClick) && 
                                    <img src={searchCloseIcon} alt='closeIcon' className='closeIcon' onClick={handleCloseSearch} />
                                }
                            </div>
                        : <></>
                        }
                        <div 
                            className='createScheduleButtonContainer' 
                            style={{ display: (singleSessionDetail?.wsId || isSearchClick) ? "none" : "flex", visibility: (role === SCHOOL_ADMIN) ? 'visible' : 'hidden'}}>
                            {
                                (singleSessionDetail?.wsId) &&  !isVideoUploaded ?
                                <></>
                                : (allSavedUploadedVideosList && totalCount === 0) && (liveSessionsList?.length === 0) && (overallCount === 0) ?
                                <></>
                                :
                                <button className='scheduleMeetBtnStyle' onClick={handleClickScheduleMeeting}>
                                    {getScreenDimensions()?.isMobileScreen ? <img src={plusIcon} alt='plusicon'/>  : "Schedule meeting"}
                                </button>
                            }
                                <div className='workshopUploadContainer' style={{ visibility : (role === SCHOOL_ADMIN) ? 'visible' : 'hidden'}} onClick={handleClickUploadIcon}>
                                {/* <div className='workshopUploadContainer'> */}
                                    <img src={uploadCloud} alt="upload" className='uploadImage' />
                                </div>
                        </div>
                    </div>
                </>
        }
        {
                // (!loading) && (singleSessionDetail?.wsId && role === TEACHER_ROLE) ?
                // <JoinWorkshop setSingleSessionDetail={setSingleSessionDetail} singleSessionDetail ={singleSessionDetail}/>
                // :
                <div 
                    className='workshopContentContainer'
                    style={{
                        marginBottom: showNoWorkshopsDiv ? '100px' : '',
                        flexDirection: showCreateScheduling ? 'column' : 'unset',
                        alignItems: showCreateScheduling ? 'center' : 'unset'
                    }}
                >
                    {(loading || getAllVideoLoading || getSchoolAdminWorkshopLoading) && !clickedVideoUrl && !hasMore && <Loader bottom='90px'/>}
                    {
                    showNoWorkshopsDiv
                    ?
                        <div className='NoWorkshops'>
                                <img alt='gif' src={ScheduleWorkshopGif} className='scheduleMeetGifStyle'/>
                                <div className='ctaStyle' style={{ cursor: ( role === SCHOOL_ADMIN) ? 'pointer' : 'default' }} onClick={handleClickScheduleMeeting}>
                                    {(role === SCHOOL_ADMIN) && <img alt='playBtn' src={BluePlayButton} className='playButtonStyle'/>}
                                    <div className='textStyle'>{(role === SCHOOL_ADMIN) ? `Schedule Meeting` : `No Workshops Created Yet!`}</div>
                                </div>
                        </div>
                    : (!clickedVideoUrl && showCreateScheduling) 
                    ? <></>
                    : 
                        ((!loading && !(getAllVideoLoading || getSchoolAdminWorkshopLoading) && !clickedVideoUrl) || (hasMore && !clickedVideoUrl)) && 
                            <WorkshopLibrary
                                setEditClicked={setEditClicked}
                                setClickedVideoUrl = {setClickedVideoUrl} 
                                setClickedVideoData={setClickedVideoData}
                                setClickedVideoDescription = {setClickedVideoDescription}
                                allSavedUploadedVideosList = {allSavedUploadedVideosList} 
                                setSingleSessionDetail={setSingleSessionDetail} 
                                singleSessionDetail={singleSessionDetail} 
                                upcomingSessionList = {liveSessionsList} 
                                setShowCreateScheduling = {setShowCreateScheduling}
                                setClickedSessionDetails={setClickedSessionDetails}
                                clickedSessionDetails= {clickedSessionDetails}
                                setIsDeleted={setIsDeleted}
                                fetchUpcomingSessions={fetchUpcomingSessions}
                                setIsClickedSessionDetail={setIsClickedSessionDetail}
                                isClickedSessionDetail={isClickedSessionDetail}
                                setSessionEnded = {setSessionEnded}
                                sessionEnded = {sessionEnded}
                                loading = {loading}
                                activeTab = {activeTab}
                                setActiveTab = {setActiveTab}
                                getAllVideoLoading={getAllVideoLoading || getSchoolAdminWorkshopLoading}
                                setIsAdminButtonClicked = {setIsAdminButtonClicked}
                                isAdminButtonClicked = {isAdminButtonClicked}
                                setIsTeacherButtonClicked = {setIsTeacherButtonClicked}
                                isTeacherButtonClicked = {isTeacherButtonClicked}
                                SetIsMoreClick = {SetIsMoreClick}
                                isMoreClick = {isMoreClick}
                                handleStartMeeting = {handleStartMeeting}
                                handleJoinMeeting = {handleJoinMeeting}
                                fetchSessionDetails = {fetchSessionDetails}
                                loadMore={loadMore}
                                hasMore={hasMore}
                                setHasMore={setHasMore}
                                totalCount={totalCount}
                                setAllSavedUploadedVideosList={setAllSavedUploadedVideosList}
                                setOffset={setOffset}
                                handleClickScheduleMeeting={handleClickScheduleMeeting}
                                isVideoUploaded={isVideoUploaded}
                                isSearchClick={isSearchClick}
                                setIsEditVideo = {setIsEditVideo}
                                setIsWorkshopUploadOpen = {setIsWorkshopUploadOpen}
                                setWorkshopOpen = {setWorkshopOpen}
                                setSelectedSingleVideo = {setSelectedSingleVideo} 
                            />
                    }
                    {/* for mobile screen */}
                    {(!isSearchClick && getScreenDimensions()?.isMobileScreen && 
                     !(loading || clickedVideoUrl || getAllVideoLoading || getSchoolAdminWorkshopLoading) && 
                     !(showCreateScheduling || (singleSessionDetail?.wsId && (role === TEACHER_ROLE)))) && (
                        <div className='workshopUploadContainerMobile' style={{ visibility : role === SCHOOL_ADMIN ? 'visible' : 'hidden'}} onClick={handleClickUploadIcon}>
                            <img src={uploadCloud} alt="upload" className='uploadImage' />
                        </div>
                    )}
                    {
                        !clickedVideoUrl && showCreateScheduling ?
                        <CreateSchedule 
                            setShowCreateScheduling={setShowCreateScheduling} 
                            clickedSessionDetails={clickedSessionDetails}
                            component={"workshop"}
                            setEditClicked={setEditClicked}
                            editClicked={editClicked}
                        />
                        : <></>
                    }
                </div>
        }
        {
            clickedVideoUrl && 
            <div className='detailView'>
                <video 
                    src={clickedVideoUrl} 
                    ref={videoRef}
                    onMouseOut={handleOnMouseOut}
                    autoPlay 
                    disablePictureInPicture 
                    controls 
                    controlsList='nodownload noplaybackrate' 
                    loop 
                    className='detailVideoTagStyle' 
                    style={{outline: 'none', border: 'none', objectFit: 'contain', backgroundColor: '#3a3a3a' }}
                />
                <img alt="closeIcon" src={whiteCrossIcon} className={(role === SCHOOL_ADMIN) ? 'adminWhiteCrossIcon':'whiteCrossIcon'} onClick={(event) => {
                    let prevVideoRef;
                    if(videoRef.current) {
                        prevVideoRef = {
                            currentTime : videoRef.current.currentTime
                        }
                    }
                    onClickCloseIcon(event, prevVideoRef);
                }} />
            </div>
        }
        {isWorkshopUploadOpen && selectedSingleVideo && isEditVideo && 
            <FileUpload 
                page="Workshop" 
                name = "workshopVideo" 
                type='video' 
                isEdit = {isEditVideo} 
                setIsEdit = {setIsEditVideo} 
                selectedFileData = {selectedSingleVideo} 
                setHasSubmittedForEdit={setHasSubmittedForEdit} 
                setWorkshopDescription = {setWorkshopDescription} 
                setUrl={setVideoUrl} 
                open={workshopOpen} 
                setOpen={setWorkshopOpen}  
                setIsUploadOpen={setIsWorkshopUploadOpen} 
                folderName="materials" 
                setFilename={setVideoFileName} 
                setFileData={setVideoFileData} 
                setUploadFailed={setWorkshopUploadFailed} 
                setUploadProgress={setWorkshopUploadProgress} 
                setuploaded={setWorkshopUploaded} 
                setUploadFileName={setWorkshopUploadFileName} 
            />}
        {isWorkshopUploadOpen && !isEditVideo && 
            <CommonBulkUpload 
                page="Workshop" 
                name = "workshopVideo" 
                type='video' 
                setUploadedPayloads = {setUploadedPayloads} 
                setFilesStatusData = {setFilesStatusData} 
                setTotalProgress = {setTotalProgress} 
                setSuccessCount = {setSuccessCount} 
                setFailureCount = {setFailureCount} 
                setWorkshopDescription = {setWorkshopDescription} 
                setUrl={setVideoUrl} 
                open={workshopOpen} 
                setOpen={setWorkshopOpen}  
                setIsUploadOpen={setIsWorkshopUploadOpen} 
                folderName="materials" 
                setFilename={setVideoFileName} 
                setFileData={setVideoFileData} 
                setUploadFailed={setWorkshopUploadFailed} 
                setUploadProgress={setWorkshopUploadProgress} 
                setuploaded={setWorkshopUploaded} 
                setUploadFileName={setWorkshopUploadFileName} 
            />}
        {workshopUploaded && 
            <UploadToaster 
                successCount = {successCount} 
                failureCount={failureCount} 
                FilesStatusData = {FilesStatusData} 
                setFilesStatusData = {setFilesStatusData} 
                totalProgress = {totalProgress} 
                setTotalProgress = {setTotalProgress} 
                uploaded={workshopUploaded} 
                setuploaded={setWorkshopUploaded} 
                uploadProgress={workshopUploadProgress} 
                setUploadProgress={setWorkshopUploadProgress} 
                fileName={workshopUploadFileName} 
                setUploadFileName={setWorkshopUploadFileName} 
                uploadFailed={workshopUploadFailed} 
                setUploadFailed={setWorkshopUploadFailed} 
            />}
            <UploadResultModal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                results={uploadResults}
                uploadResultsForTeacher = {upoloadResultsForWorkshop}
                page='workshopupload'
            />
    </div>
  )
}

export default Workshop
